<template>
  <div>
      <section class="section is-medium">
    <div class="container">
      
      
      <div class="columns is-centered">
        <div class="column is-8">
          <div class="content is-medium">
            <h1>Planned Features</h1>

<p>I&#39;ve planned to implement these features—no particular order and no fixed timeline at the moment. Also, if something is missing but you need it, send me an email.</p>

<ul>
<li>Thank You Pages (TYP) per voting option. Currently, it&#39;s a single one.</li>
<li>Customizing the Why text on the extended feedback page (EFP) per option. Currently, it&#39;s one text and the same regardless of the vote.</li>
<li>5 star rating with svg icons in web rating widget</li>
<li>Make rating calculation for web rating widget configurable (MODE, Average, Median)</li>
<li>Pixel for tracking <q>views</q> in newsletters; similar to the open rate in email providers. Or better to connect to email provider and retrieve the open rate?</li>
<li>Creating documentation and writing how-tos</li>
</ul>


          </div>
        </div>
      </div>
    </div>
  </section>
  </div>
</template>

<script>
export default {
  name: "upcoming",
  data: function () {
    return {

    };
  },
  methods: {
    
  },
};
</script>

